<template>
    <div class="gh-newsletter gh-newsletter--inline">
        <div class="container">
            <div class="gh-newsletter__intro">
                <img
                    class="gh-newsletter__icon"
                    src="/images/app/newsletter/news-icon.svg"
                    width="54" height="54" loading="lazy" alt=""
                />

                <div class="gh-newsletter__copy">
                    <p class="gh-newsletter__heading">Join thousands of therapists receiving America’s most trusted mental health newsletter</p>
                    <p class="gh-newsletter__subheading">Evidence-informed articles, expert insights and practical clinical resources - delivered weekly.</p>
                </div>
            </div>

            <gh-newsletter-signup-inline/>

            <ul class="gh-newsletter__trust">
                <li class="gh-newsletter__trust-item">
                    <img src="/images/app/newsletter/free.svg" width="20" height="20" loading="lazy" alt=""/>
                    <span>Free</span>
                </li>
                <li class="gh-newsletter__trust-item">
                    <img src="/images/app/newsletter/delivered-weekly.svg" width="20" height="20" loading="lazy" alt=""/>
                    <span>Delivered weekly</span>
                </li>
                <li class="gh-newsletter__trust-item">
                    <img src="/images/app/newsletter/unsubscribe.svg" width="20" height="20" loading="lazy" alt=""/>
                    <span>Unsubscribe anytime</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import ghNewsletterSignupInline from '@/modules/newsletter/components/NewsletterSignupInline';

    export default {
        components: {ghNewsletterSignupInline}
    }
</script>
